import { NgModule } from '@angular/core';

/** Componentes */
import { LoaderComponent } from './loader.component';
import { LoaderService } from './loader.service';
import { MatProgressBarModule } from '@angular/material';

@NgModule({
  declarations: [
    LoaderComponent
  ],
  imports: [MatProgressBarModule],
  exports: [LoaderComponent],
  entryComponents:[],
  providers: [LoaderService],
  bootstrap: [LoaderComponent]
})
export class LoaderModule { }
